import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { languageChangeActions } from "../../../redux/actions/languageToggler.action";
import { Directions, Languages } from "../../../constants";
import { setLocalStorageItem } from "../../../system";
import { useLocation, useNavigate } from "react-router-dom";

function LanguageToggler() {
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const language = useSelector((state) => {
    return state.LanguageChangeReducer.language;
  });
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const wordpressLanguage = queryParams.get('lang');
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    if (e === Languages.EN || e?.currentTarget?.checked) {
      dispatch(
        languageChangeActions.changeLanguage({
          direction: Directions.ltr,
          language: Languages.EN,
        })
      );
      setLocalStorageItem("direction", Directions.ltr);
      setLocalStorageItem("language", Languages.EN);
    } else {
      dispatch(
        languageChangeActions.changeLanguage({
          direction: Directions.rtl,
          language: Languages.AR,
        })
      );
      setLocalStorageItem("direction", Directions.rtl);
      setLocalStorageItem("language", Languages.AR);
    }
  };

  useEffect(() => {
    i18n.changeLanguage(language);
    document.body.dir = direction;
    // eslint-disable-next-line
  }, [language]);

  useEffect(() => {
    if (wordpressLanguage) {
      changeLanguage(wordpressLanguage);
      // Create a URL object from the current location
      const url = new URL(window.location.href);

      // Check if 'lang' parameter is present in the URL
      if (url.searchParams.has('lang')) {
        // Delete the 'lang' parameter from the URL
        url.searchParams.delete('lang');

        // Update the browser history with the new URL (without reloading the page)
        navigate(`${url.pathname}?${url.searchParams.toString()}`, { replace: true });
      }
    }
  }, [wordpressLanguage])

  return (
    <div className="switch">
      <input
        id="language-toggle"
        className="check-toggle check-toggle-round-flat"
        type="checkbox"
        checked={language === Languages.EN}
        onChange={changeLanguage}
      />
      <label htmlFor="language-toggle"></label>
      <span className="on">AR</span>
      <span className="off">EN</span>
    </div>
  );
}

export default LanguageToggler;
